// extracted by mini-css-extract-plugin
export var closeButton = "_nf-2";
export var closeButtonIcon = "_nf-3";
export var lightboxContent = "_nf-1";
export var lightboxOverlay = "_nf-0";